export const environment = {
  production: true,
  // apiUrl: '/api/',
  apiUrl: 'https://api.card4games.com/v1/',
  admin_email: 'admin@admin.com',
  sentryDsn: 'https://c78c817397f5a2f34b09d3f69f458287@o4508517617303552.ingest.de.sentry.io/4508517619728464', // ممكن تستخدم نفس الـ DSN
  sentryEnvironment: 'production',

};
